var map = {
	"./card_1.jpg": "c6b5",
	"./card_default.png": "0788",
	"./history_record_1.jpg": "d6b6",
	"./logo.png": "4ffd",
	"./logo2x.png": "6d09",
	"./logo_elegance.png": "f556",
	"./logo_elegance2x.png": "7aa9",
	"./logo_footer2x.png": "975d",
	"./map.png": "48dd",
	"./order_1.jpg": "5398",
	"./svg/call.svg": "e62a",
	"./svg/chevron-down.svg": "ff7b",
	"./svg/chevron-up.svg": "d02a",
	"./svg/close.svg": "58a4",
	"./svg/cooking.svg": "0715",
	"./svg/delivery.svg": "9345",
	"./svg/dish.svg": "8cf3",
	"./svg/email.svg": "b267",
	"./svg/empty_favorites.svg": "1514",
	"./svg/eye.svg": "4111",
	"./svg/fb.svg": "6076",
	"./svg/filter.svg": "a1d2",
	"./svg/heart.svg": "a7ad",
	"./svg/insta.svg": "5f07",
	"./svg/location.svg": "c391",
	"./svg/logout.svg": "8668",
	"./svg/mail.svg": "0cc2",
	"./svg/menu.svg": "c399",
	"./svg/message-alt.svg": "1ce9",
	"./svg/message.svg": "7501",
	"./svg/payment_logos.svg": "de72",
	"./svg/phone.svg": "7b69",
	"./svg/pin.svg": "f95b",
	"./svg/shopping-cart.svg": "2d5e",
	"./svg/user.svg": "be92"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";